/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The hopper level fill color variant.
 */
export const AnimaticHopperConfigVariant = {
  Default: "default",
  Critical: "critical",
  Warning: "warning",
  Caution: "caution",
} as const;
/**
 * The hopper level fill color variant.
 */
export type AnimaticHopperConfigVariant = OpenEnum<
  typeof AnimaticHopperConfigVariant
>;

/**
 * The configuration of the animatic for a hopper. State and labels are carried by the animatic primitive states and animatic labels, not here.
 */
export type AnimaticHopperConfig = {
  /**
   * A reference to a reading or setting.
   */
  level?: Ref | undefined;
  /**
   * The hopper level fill color variant.
   */
  variant?: AnimaticHopperConfigVariant | undefined;
};

/** @internal */
export const AnimaticHopperConfigVariant$inboundSchema: z.ZodType<
  AnimaticHopperConfigVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticHopperConfigVariant);
/** @internal */
export const AnimaticHopperConfigVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticHopperConfigVariant
> = openEnums.outboundSchema(AnimaticHopperConfigVariant);

/** @internal */
export const AnimaticHopperConfig$inboundSchema: z.ZodType<
  AnimaticHopperConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  level: types.optional(Ref$inboundSchema),
  variant: types.optional(AnimaticHopperConfigVariant$inboundSchema),
});
/** @internal */
export type AnimaticHopperConfig$Outbound = {
  level?: Ref$Outbound | undefined;
  variant?: string | undefined;
};

/** @internal */
export const AnimaticHopperConfig$outboundSchema: z.ZodType<
  AnimaticHopperConfig$Outbound,
  z.ZodTypeDef,
  AnimaticHopperConfig
> = z.object({
  level: Ref$outboundSchema.optional(),
  variant: AnimaticHopperConfigVariant$outboundSchema.optional(),
});

export function animaticHopperConfigToJSON(
  animaticHopperConfig: AnimaticHopperConfig,
): string {
  return JSON.stringify(
    AnimaticHopperConfig$outboundSchema.parse(animaticHopperConfig),
  );
}
export function animaticHopperConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticHopperConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticHopperConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticHopperConfig' from JSON`,
  );
}
